import React from 'react'
import { Button, Container, Grid, Paper, Theme, Typography } from '@mui/material'
import { makeStyles } from '@mui/styles'
import DOMPurify from 'dompurify'
import KeyboardArrowLeftRounded from '@mui/icons-material/KeyboardArrowLeftRounded'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { ITemplateProps } from './ProfessocialExternalLinks'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    width: '100%',
    padding: theme.spacing(5),
  },
  button: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.body1.fontSize,
    textTransform: 'initial',
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
  },
}))

const Privacy: React.FC<ITemplateProps> = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <Container maxWidth='lg'>
      <Grid container columnSpacing={2} sx={{ px: 2, pb: 6 }}>
        <Button
          className={classes.button}
          startIcon={<KeyboardArrowLeftRounded />}
          variant='text'
          color='info'
          onClick={() => history.goBack()}
        >{t('coreCommon:backToPAge')}
        </Button>
        <Paper className={classes.paper}>
          {props.topInformation && (
            <Typography variant='h4' sx={{ mb: 2 }}>
              {props.topInformation}
            </Typography>
          )}
          <Typography variant='h2' sx={{ mb: 2 }}>
            {props.title}
          </Typography>
          <Typography dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.text) }} />
        </Paper>
      </Grid>
    </Container>
  )
}

export default Privacy
